export default __webpack_public_path__ + "static/media/storycards_logo_no_text.870ff03d.svg";